<script>
  import ItemPage from '../components/ItemPage.vue'

  export default {
    components: { ItemPage },
  }
</script>


<template>
  <ItemPage :narrowCols="[1,2,3,4]">

    <template #title>
      <span>さとみん☆の</span>
      <span>プリチャンコーデあつめ</span>
    </template>

    <template #col1>
      <section class="PageIndex">
        <h2>2021年度</h2>
        <ul>
          <li><router-link to="/PAF01">プリティーオールフレンズ1弾</router-link></li>
          <li><router-link to="/PAF02">プリティーオールフレンズ2弾</router-link></li>
          <li><router-link to="/PAF03">プリティーオールフレンズ3弾</router-link></li>
          <li><router-link to="/Promo2021">プロモ2021<small>いろいろ</small></router-link></li>
        </ul>
      </section>
    </template>

    <template #col2>
      <section class="PageIndex">
        <h2>2020年度</h2>
        <ul>
          <li><router-link to="/PriTama01">プリたま1弾</router-link></li>
          <li><router-link to="/PriTama02">プリたま2弾</router-link></li>
          <li><router-link to="/PriTama03">プリたま3弾</router-link></li>
          <li><router-link to="/PriTama04">プリたま4弾</router-link></li>
          <li><router-link to="/PriTama05">プリたま5弾</router-link></li>
          <li><router-link to="/PriTama06">プリたま6弾</router-link></li>
          <li><router-link to="/Promo2020">プロモ2020<small>いろいろ</small></router-link></li>
          <li><router-link to="/Promo2020/Ptgo">プロモ2020<small>プリたまGO連動</small></router-link></li>
        </ul>
      </section>
    </template>

    <template #col3>
      <section class="PageIndex">
        <h2>2019年度</h2>
        <ul>
          <li><router-link to="/Jewel01">ジュエル1弾</router-link></li>
          <li><router-link to="/Jewel02">ジュエル2弾</router-link></li>
          <li><router-link to="/Jewel03">ジュエル3弾</router-link></li>
          <li><router-link to="/Jewel04">ジュエル4弾</router-link></li>
          <li><router-link to="/Jewel05">ジュエル5弾</router-link></li>
          <li><router-link to="/Jewel06">ジュエル6弾</router-link></li>
          <li><router-link to="/JewelCoords">ジュエルコーデ</router-link></li>
          <li><router-link to="/Promo2019/Toys">プロモ2019<small>おもちゃ系</small></router-link></li>
          <li><router-link to="/Promo2019/Perif">プロモ2019<small>周辺商品系</small></router-link></li>
          <li><router-link to="/Promo2019/Pact">プロモ2019<small>ジュエルパクト連動</small></router-link></li>
          <li><router-link to="/Promo2019/Events">プロモ2019<small>イベント系</small></router-link></li>
        </ul>
      </section>
    </template>

    <template #col4>
      <section class="PageIndex">
        <h2>2018年度</h2>
        <ul>
          <li><router-link to="/Vol01">第1弾</router-link></li>
          <li><router-link to="/Vol02">第2弾</router-link></li>
          <li><router-link to="/Vol03">第3弾</router-link></li>
          <li><router-link to="/Vol04">第4弾</router-link></li>
          <li><router-link to="/Vol05">第5弾</router-link></li>
          <li><router-link to="/Vol06">第6弾</router-link></li>
          <li><router-link to="/Promo2018">プロモ2018<small>いろいろ</small></router-link></li>
        </ul>
      </section>
    </template>

    <template #col5>
      <section class="PageIndex">
        <h2>プリチケパック／グミ</h2>
        <ul>
          <li><router-link to="/PritickeGummy">プリチケコレクショングミ</router-link></li>
          <li><router-link to="/PristaPack">プリスタパック</router-link></li>
          <li><router-link to="/PritickePack01">プリチケパック1</router-link></li>
          <li><router-link to="/PritickePack02">プリチケパック2</router-link></li>
          <li><router-link to="/PritickePack03">プリチケパック3</router-link></li>
          <li><router-link to="/KiraKiraPack01">キラキラパック<small>キラッツ編</small></router-link></li>
          <li><router-link to="/KiraKiraPack02">キラキラパック<small>メルスタ編</small></router-link></li>
          <li><router-link to="/KiraKiraPack03">キラキラパック<small>オールアイドル編</small></router-link></li>
          <li><router-link to="/PritickePack07">プリチケパック<small>プリたま編Vol.1</small></router-link></li>
        </ul>
      </section>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  .PageIndex {
    $spacing: $size-unit * 5;

    & {
      display: block;
      margin: 0;
      padding: 0;
    }

    h2 {
      display: block;
      margin: 0 0 0 4px;
      padding: 0;
      color: red;
      font-family: $font-family--fancy;
      font-size: $size-unit * 7;
      filter: saturate(1.25);
      text-shadow:  0px  4px 1px #fff,
                    1px  4px 1px #fff,
                    2px  4px 1px #fff,
                    3px  3px 1px #fff,
                    4px  2px 1px #fff,
                    4px  1px 1px #fff,
                    4px  0px 1px #fff,
                    4px -1px 1px #fff,
                    4px -2px 1px #fff,
                    3px -3px 1px #fff,
                    2px -4px 1px #fff,
                    1px -4px 1px #fff,
                    0px -4px 1px #fff,
                   -1px -4px 1px #fff,
                   -2px -4px 1px #fff,
                   -3px -3px 1px #fff,
                   -4px -2px 1px #fff,
                   -4px -1px 1px #fff,
                   -4px  0px 1px #fff,
                   -4px  1px 1px #fff,
                   -4px  2px 1px #fff,
                   -3px  3px 1px #fff,
                   -2px  4px 1px #fff,
                   -1px  4px 1px #fff,
                    0px  4px 1px #fff;
    }

    ul {
      display: block;
      margin: $spacing 0;
      padding: 0;
    }

    li {
      display: block;
      margin: $spacing 0;
      padding: 0;
    }

    a {
      display: block;
      max-width: $size-unit * 100;
      margin: 0;
      padding: $spacing;
      border: ($size-unit / 2) solid rgba(red, 0.5);
      border-radius: $spacing;
      color: red;
      background: darken($page-bg-color, 5%);
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: $size-unit * 5;
      font-weight: bold;
      outline: none;
      transition: all 350ms ease;
      text-shadow:  0px  1px 1px white,
                    1px  1px 1px white,
                    1px  0px 1px white,
                    1px -1px 1px white,
                    0px -1px 1px white,
                   -1px -1px 1px white,
                   -1px  0px 1px white,
                   -1px  1px 1px white;

      &:hover,
      &:focus {
        background: darken($page-bg-color, 10%);
      }

      small {
        margin: 0 0 0 0.5em;
        padding: 0;
        font-size: 75%;
      }
    }
  }
</style>
